import Plp from "./PLP";

export default Plp;
